import { Schema } from 'mongoose';
// tslint:disable-next-line no-var-requires
const countryCodesAlpha2 = require('../services/country-codes-alpha2.json');

export interface ITopLocation {
  city?: string;
  state?: string;
  countryCode: string;
}

const schema = new Schema(
  {
    city: {
      type: String,
      required: false,
    },
    state: {
      type: String,
      required: false,
    },
    countryCode: {
      type: String,
      required: true,
      enum: countryCodesAlpha2,
    },
  },
  { _id: false },
);

schema.virtual('country', {
  ref: 'Country',
  localField: 'countryCode',
  foreignField: 'countryCode',
  justOne: true,
});

export default schema;
